import { ListingElement } from '@app/common';
import TextWithReferences from '../TextWithReferences/TextWithReferences';

type Properties = {
    data: ListingElement;
};

const Listing = (props: Properties) => {
    const { terms, numbers } = props.data;

    let className = 'page-listing';
    if (numbers) {
        className += ' page-listing-numbers';
    }

    const elements = terms.map((term, index) => {
        return <li key={index}>
            <TextWithReferences text={term} />
        </li>;
    });

    return <ul className={className}>
        {elements}
    </ul>;
};
export default Listing;